var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"chiller_cb d-flex"},[_c('input',{attrs:{"id":"myCheckbox","type":"checkbox"},domProps:{"checked":_vm.check}}),_c('span',{on:{"click":function($event){return _vm.checkItem()}}})])])}
var staticRenderFns = []

export { render, staticRenderFns }